import * as React from "react";
import * as ReactDOMClient from "react-dom/client";
import * as ReactDOMServer from "react-dom/server";

import Components from "./Components";

// Add this before React is imported
if (typeof globalThis.setTimeout === "undefined") {
  const customSetTimeout = (fn: Function) => fn();
  (customSetTimeout as any).__promisify__ = () => {};
  globalThis.setTimeout = customSetTimeout as typeof setTimeout;
  globalThis.clearTimeout = () => {};
}

// expose React, ReactDOMServer, ReactDOMClient and Components as global variables
globalThis.React = React;
globalThis.ReactDOMServer = ReactDOMServer;
globalThis.ReactDOMClient = ReactDOMClient;
globalThis.Components = Components;
